<template>
  <div :class="classesInput">
    <label class="label"  :style="[disabled ? {'opacity': 0.5} : {'opacity': 1}]">
      <span :style="{'color':labelColor}">{{label}}</span>
      <input
        type="checkbox"
        class="input"
        v-model="value"
        v-bind="$attrs"
        v-on="$listeners"
        :disabled="disabled"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppFormCheckbox',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  props: {
    initialValue: {
      required: false,
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelColor:{
      type: String,
      default: null,
      required: false    
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      value: this.initialValue
    }
  },
  computed: {
    classesInput () {
      return {
        'input-wrapper': true,
        'input--is-dirty': this.isDirty,
        'input--is-disabled': this.disabled,
        'input--is-readonly': this.readonly
      }
    }
  },
  watch: {
    value (val) {
      this.$emit('valueChanged', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.input-wrapper {
  position: relative;
  padding-left: 30px;
  padding-top: 2px;

  .label {
    font-family: $font-text;
    font-size: $size-xs;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: $color-purple-darker;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    &:checked ~ .checkmark {
      border: solid 6px $color-purple-light;
    }
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border-radius: 4px;
    border: solid 1px rgb(208, 208, 208);
    background-color: $color-white;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }
}
</style>
